import {PackagesChart} from './PackagesChart';
import PackagesTable from './PackagesTable';
import {useSecurityDetails} from 'src/hooks/UseSecurityDetails';
import {isErrorString} from 'src/resources/ErrorHandling';
import RequestError from 'src/components/errors/RequestError';
import {
  QueuedState,
  FailedState,
  UnsupportedState,
} from 'src/routes/TagDetails/SecurityReport/SecurityReportScanStates';
import {Layer} from 'src/resources/TagResource';

export function Packages(props: PackagesProps) {
  const {data, error} = useSecurityDetails(props.org, props.repo, props.digest);

  if (isErrorString(error)) {
    return <RequestError message={error} />;
  }

  // Return correct messages for the different scan states
  if (data && data.status === 'queued') {
    return <QueuedState />;
  } else if (data && data.status === 'failed') {
    return <FailedState />;
  } else if (data && data.status === 'unsupported') {
    return <UnsupportedState />;
  }

  // Set features to a default of null to distinguish between a completed API call and one that is in progress
  const features = data ? data.data.Layer.Features : null;
  return (
    <>
      <PackagesChart features={features} />
      <hr />
      <PackagesTable features={features} layers={props.layers} />
    </>
  );
}

export interface PackagesProps {
  org: string;
  repo: string;
  digest: string;
  layers?: Layer[];
}
